/**
 * Schermteksten in het Spaans.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const es: Teksten = {
  kamerOphalen: "Cargando sala…",
  kamerWerktNiet: "Esta sala no funciona",
  serverReageertNiet: "El servidor no responde",
  probeerOpnieuw: "Inténtalo de nuevo",
  vraagNieuweCode: "Pide un código nuevo a quien lo compartió. Las salas caducan después de unas horas.",
  welkeTaalSprekJij: "¿Qué idioma hablas?",
  jouwStem: "Tu voz en la traducción",
  man: "Hombre",
  vrouw: "Mujer",
  pincode: "Código PIN",
  pincodeUitleg: "Te lo proporcionará la persona que compartió el código.",
  gaDeKamerIn: "Entra en la sala",
  kiesEerstJeTaal: "Elige primero tu idioma",
  microfoonAanvragen: "Solicitando micrófono…",
  toestemmingUitleg: "Tu navegador te pedirá permiso para usar el micrófono. Sin él, solo podrás escribir.",
  microfoonTestLink: "Prueba primero tu micrófono",
  stemGaatMee: "En esta sala, la otra persona también escuchará tu propia voz, además de la traducción.",
  alleenChatMelding: "Esta conversación es solo chat. Escribes tus mensajes y lees la traducción; no se lee nada en voz alta.",
  verlooptOm: "Caduca a las",
  nooitVasteKamer: "Nunca, sala permanente",
  kamer: "Sala",
  tolkgesprek: "Interpretación",
  juisteKamer: "Estás en la sala correcta. En un momento podrás unirte a la conversación.",
  jij: "tú",
  deAnder: "el otro",
  verbinden: "Conectando…",
  verbonden: "Conectado",
  verbindingKwijt: "Se perdió la conexión. Reconectando…",
  wachtenOpAnder: "Ya estás dentro. Esperando a que la otra persona escanee el código QR.",
  allebeiInDeKamer: "Ambos estáis en la sala.",
  anderIsWeg: "La otra persona se ha ido",
  anderSpreekt: "La otra persona habla…",
  jeKuntErNietIn: "No puedes entrar",
  overgenomenTitel: "Continuado en otro dispositivo",
  overgenomenUitleg: "Esta conversación se acaba de abrir en otro dispositivo. Continúa hablando allí.",
  terug: "Volver",
  geluidStaatUit: "El sonido está desactivado. Toca cualquier parte de la pantalla.",
  tikHier: "toca aquí",
  bewaardTot: 'Guardado hasta las {tijd}',
  bewaardVast: "Sala permanente. Los mensajes se guardan durante 30 días.",
  spreekIn: "Habla",
  luisteren: "Escuchando… toca para parar",
  uitschrijven: "Transcribiendo…",
  tijdOmTeVerbeteren: "Tiempo para corregir",
  altijdZelfVersturen: "Revisar y enviar siempre manualmente",
  jijVerstuurtZelf: "Envías tú mismo",
  uit: "desactivado",
  sec: "seg",
  vertalingMeteenAfspelen: "Reproducir traducción al instante",
  typHierJeBericht: "Escribe tu mensaje aquí…",
  stuur: "Enviar",
  geenOpnameMogelijk: "Este navegador no puede grabar audio. Pero puedes escribir.",
  verstaanAls: "Entendido como",
  tellerStaatStil: "el contador está parado",
  versturen: "Enviar",
  wis: "Borrar",
  jijZei: "dijiste",
  vertaald: "traducido",
  duimOmhoog: "Es correcto",
  duimOmlaag: "No es correcto",
  opnieuwProberenKnop: "Intentar de nuevo con un modelo mejor",
  opnieuwProberenBezig: "Traduciendo de nuevo…",
  duimTranscriptWoordenlijstUitnodiging: "¿Se entendió mal? Corrígelo en el glosario:",
  instellingenAanpassen: "Ajustar configuración",
  geldtVoorJullieBeiden: "Se aplica a ambos",
  alleenVoorJou: "Solo para ti",
  stuurMijnStemMee: "Enviar mi propia voz",
  verbeterSpelfouten: "Corregir errores ortográficos en mi texto",
  verbeterSpelfoutenUit: "Al desactivarlo se muestra exactamente lo que se entendió, con errores incluidos.",
  alleenChat: "Solo chat: sin voz, sin micrófono",
  alleenChatUitleg: "Los dos escribís. Se muestran la traducción y el texto original; no se lee nada en voz alta.",
  aangepastDoorDeAnder: "La otra persona cambió la configuración.",
  foutSpraak: "La traducción está lista, pero no se generó voz.",
  foutSpraakQuota: "Se ha agotado el límite de voz para hoy. El texto funciona con normalidad; la voz volverá mañana.",
  foutBudgetKamer: "Esta conversación ha alcanzado su límite, así que la traducción está en pausa. Quien la creó puede aumentarlo; después vuelve a funcionar enseguida.",
  foutBudgetMaand: "Se ha agotado el presupuesto mensual de la aplicación. La traducción volverá a funcionar cuando el administrador lo ajuste.",
  foutTaal: "Ese idioma no es válido: ambos estaríais hablando el mismo.",
  origineel: "original",
  vertalen: "Traduciendo…",
  vertalenMislukt: "No se pudo traducir.",
  opnieuwAfspelen: "Volver a reproducir traducción",
  hoorDeAnder: "Escucha cómo lo dijo la otra persona",
  woordenlijst: "Glosario de respaldo",
  woordenlijstUitleg: "¿La aplicación entiende mal de forma sistemática un nombre o término técnico? Define aquí lo que significa.",
  hijHoort: "entiende…",
  jijBedoelt: "quieres decir…",
  ookVolgendeGesprekken: "También en próximas conversaciones — de lo contrario, solo se aplica aquí",
  voegToe: "Añadir",
  bezig: "Procesando…",
  lijstNietGeladen: "No se pudo cargar la lista.",
  toevoegenMislukt: "No se pudo añadir.",
  verwijderenMislukt: "No se pudo eliminar.",
  overal: "en todas partes",
  verwijder: "Eliminar",
  overDitGesprek: "Sobre esta conversación",
  toon: "Tono de la traducción",
  sfeer: "Ambiente de la conversación",
  jouwPlek: "Tu lugar",
  hoeHetWerkt: "El servidor transcribe tu grabación y la traduce de golpe. Tu propia voz se envía a la otra persona.",
  kleinereTekst: "Texto más pequeño",
  grotereTekst: "Texto más grande",
  insprekenVerbergen: "Ocultar dictado",
  insprekenTonen: "Mostrar dictado",
  toetsenbordVerbergen: "Ocultar teclado",
  toetsenbordTonen: "Mostrar teclado",
  vormAutomatisch: "Automático",
  vormInformeel: "Tú (informal)",
  vormFormeel: "Usted (formal)",
  sfeerNeutraal: "Neutral",
  sfeerZakelijk: "Profesional",
  sfeerOfficieel: "Oficial",
  sfeerVriendschappelijk: "Amistoso",
  sfeerPartner: "Pareja",
  foutKamerVol: "Esta sala está llena. Solo pueden entrar dos personas.",
  plekBezetTitel: "Tu lugar está ocupado",
  plekBezetUitleg: "Alguien ya ocupa tu lado de esta conversación, en tu idioma. Casi siempre eres tú: la conversación sigue abierta en otro dispositivo o en otra pestaña. Ciérrala allí y vuelve a intentarlo. A veces tarda un minuto y medio en quedar libre.",
  plekBezetWissel: "¿Eres tú? Escribe WISSEL para traer la conversación a este dispositivo. El otro dispositivo se cerrará.",
  plekBezetKnop: "Traer a este dispositivo",
  foutKamerVerlopen: "Esta sala ha caducado o está cerrada.",
  foutKamerOnbekend: "Esta sala no existe.",
  foutPinNodig: "Esta sala requiere un código PIN.",
  foutPinFout: "El código PIN no es correcto.",
  foutProtocol: "La aplicación y el servidor no se entienden. Recarga la página.",
  foutMicroGeweigerd: "Has rechazado el acceso al micrófono. Haz clic en el candado de la barra de direcciones y actívalo.",
  foutGeenMicro: "No se ha encontrado ningún micrófono. Conecta uno e inténtalo de nuevo.",
  foutMicroInGebruik: "El micrófono está siendo usado por otro programa. Ciérralo e inténtalo de nuevo.",
  foutGeenHttps: "El micrófono solo funciona en una conexión segura. Abre esta página a través de https.",
  foutMicroOnbekend: "No se pudo iniciar el micrófono.",
  foutNietsOpgenomen: "No se ha grabado nada. ¿Está encendido tu micrófono?",
  foutNietsGehoord: "No se ha escuchado nada. ¿Está encendido tu micrófono y hablas lo suficientemente alto?",
  foutOpnameTeLang: "La grabación es demasiado larga. Habla en fragmentos más cortos.",
  foutMicroGedempt: "Tu micrófono está silenciado. Actívalo e inténtalo de nuevo.",

  // --- microfoontest ---
  micTitel: "Prueba de micrófono",
  micOnderschrift: "Cuatro pruebas seguidas, cinco segundos cada una. Sigue hablando todo el rato.",
  micStart: "Iniciar la prueba",
  micTest1: "1. Solo reconocimiento",
  micTest2: "2. Solo grabación",
  micTest3: "3. Juntos — grabación primero",
  micTest4: "4. Juntos — reconocimiento primero",
  micFase1: "1 de 4: solo reconocimiento — di una frase corta",
  micFase2: "2 de 4: solo grabación — sigue hablando",
  micFase3: "3 de 4: grabación primero, luego reconocimiento — sigue hablando",
  micFase4: "4 de 4: reconocimiento primero, luego grabación — sigue hablando",
  micKlaar: "listo",
  micGehoord: "oído",
  micOpnameformaat: "Formato de grabación",
  micGeen: "ninguno",
  micBeveiligd: "Conexión segura",
  micJa: "sí",
  micNee: "NO",
  micBrowser: "Navegador",
  micGeenHttps: "Sin https el navegador no libera el micrófono. En localhost sí se permite.",
  micGeenHerkenning: "Este navegador no tiene reconocimiento de voz.",
  micZegIets: "di algo…",
  micWoordenBinnen: "están llegando palabras",
  micKonNietStarten: "no pudo iniciarse",
  micGeenRecorder: "Este navegador no conoce MediaRecorder.",
  micOpnemen: "grabando…",
  micNietsOpgenomen: "no se grabó nada",
  micGeenMicrofoon: "sin micrófono",
  micOpnameEerst: "grabación primero…",
  micHerkenningEerst: "reconocimiento primero…",
  micOpnameStarttNiet: "la grabación no se inició",
  micSamenGelukt: "Juntos. Grabación {kb} kB.",
  micAlleenOpname: "Grabación sí, reconocimiento no.",
  micAlleenHerkenning: "Reconocimiento sí, grabación no.",
  micGeenVanBeide: "Ninguno de los dos.",
  micNetwerkFout: "El reconocimiento de voz no pudo llegar al servidor.",
  micAfgebroken: "La grabación se interrumpió.",
  verslagTitel: "Acta de la conversación",
  verslagWie: "Quién",
  verslagOrigineel: "Original",
  verslagVertaling: "Traducción",
  verslagSpreker: "Interlocutor {x}",
  verslagBerichten: "Mensajes",
  verslagGemaaktOp: "Creado",
  verslagGeenOpname: "No es una grabación literal.",
  verslagNootOrigineel: "«Original» es el texto tal como la aplicación entendió a quien hablaba.",
  verslagNootCorrectie: "La corrección ortográfica estaba activada: se corrigieron pequeños errores de escritura.",
  verslagNootAangepast: "Quien habló pudo modificar el texto antes de enviarlo.",
  verslagGesproken: "hablado",
  verslagGetypt: "escrito",
  verslagMislukt: "La traducción falló. La otra persona no vio esta frase en su idioma.",
  verslagNietKlaar: "La traducción aún no estaba lista cuando se creó esta acta.",
  verslagVertrouwelijk: "Confidencial.",
  verslagAlleenDeelnemers: "Esta acta contiene el contenido de una conversación privada y está destinada solo a los participantes.",
  verslagGewist: "Fecha de eliminación de la conversación: {tijd}. Después, esta acta no podrá volver a generarse.",
  verslagGewistVast: "Sala permanente: cada mensaje se elimina 30 días después de su envío. Los mensajes más antiguos no aparecen en este informe.",
};
